import IDate from '@shared/types/interfaces/date';
import { EpgQueryInfo } from '@shared/types/interfaces/query';

/******************/
/**     INFO     **/
/******************/

/**
 * Query related constants
 */
const DAYS_TO_LOAD = 7;

/**
 * @param channelIds Channel identifiers to fetch
 * @returns {EpgQueryInfo} Epg query info
 */
export default function info(
  channelIds: string[],
  dateRange?: IDate
): EpgQueryInfo {
  let beginTime: string;
  let endTime: string;
  if (dateRange) {
    beginTime = new Date(dateRange?.start ?? 0).toISOString();
    endTime = new Date(dateRange?.end ?? 0).toISOString();
  } else {
    const date = new Date();
    date.setHours(date.getHours(), 0, 0, 0);
    beginTime = date.toISOString();
    date.setDate(date.getDate() + DAYS_TO_LOAD);
    date.setHours(date.getHours(), 0, 0, 0);
    endTime = date.toISOString();
  }
  return {
    query: {
      beginTime,
      endTime,
      channelIds,
    },
  };
}
